import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import gsap from 'gsap';
import Btn from '../components/common/btn.jsx';
import './Onboarding.css';
import './genarel.css';


const Onboarding2 = () => {
    const squareOuterRef = useRef(null);
    const squareInnerRef = useRef(null);
    const archRef = useRef(null);
    const iconRef = useRef(null);
    const titleRef = useRef(null);
    const paraRef = useRef(null);
    const dotsRef = useRef(null);
    const btnRef = useRef(null);

    useEffect(() => {
        const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

        gsap.set([squareOuterRef.current, squareInnerRef.current], { opacity: 0, scale: 0.5 });
        gsap.set(archRef.current, { opacity: 0, scale: 0.7, y: 40 });
        gsap.set(iconRef.current, { opacity: 0, rotation: 180, scale: 0 });
        gsap.set(titleRef.current, { opacity: 0, y: 30, skewX: 5 });
        gsap.set(paraRef.current, { opacity: 0, y: 20 });
        gsap.set(dotsRef.current, { opacity: 0 });
        gsap.set(btnRef.current, { opacity: 0, scale: 0.9 });

        tl.to(squareOuterRef.current, { opacity: 1, scale: 1, rotation: -10, duration: 0.7 })
          .to(squareInnerRef.current, { opacity: 1, scale: 1, rotation: 6, duration: 0.6 }, '-=0.4')
          .to(archRef.current, { opacity: 1, scale: 1, y: 0, duration: 0.65 }, '-=0.4')
          .to(iconRef.current, { opacity: 1, rotation: 0, scale: 1, duration: 0.55 }, '-=0.3')
          .to(titleRef.current, { opacity: 1, y: 0, skewX: 0, duration: 0.6 }, '-=0.2')
          .to(paraRef.current, { opacity: 1, y: 0, duration: 0.5 }, '-=0.3')
          .to(dotsRef.current, { opacity: 1, duration: 0.4 }, '-=0.2')
          .to(btnRef.current, { opacity: 1, scale: 1, duration: 0.4 }, '-=0.2');
    }, []);

    return (
        <div className="ob-wrapper">
            <div className="mobile-container">
                <main className="ob-screen">

                    <div className="ob-visual-area" aria-hidden="true">
                        <div className="ob-square-outer" ref={squareOuterRef}></div>
                        <div className="ob-square-dashed" ref={squareInnerRef}></div>
                        <div className="ob-arch" ref={archRef}>
                            <span className="ob-icon" ref={iconRef}>
                                <svg width="92" height="92" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                                    <line x1="16" y1="2" x2="16" y2="6"/>
                                    <line x1="8" y1="2" x2="8" y2="6"/>
                                    <line x1="3" y1="10" x2="21" y2="10"/>
                                </svg>
                            </span>
                        </div>
                    </div>

                    <div className="ob-body">
                        <h1 className="ob-title" ref={titleRef}>Book Events Instantly</h1>
                        <p className="ob-para" ref={paraRef}>Browse upcoming events, reserve your spot, and get instant confirmation with digital tickets.</p>
                    </div>

                    <div className="ob-dots" ref={dotsRef} role="img" aria-label="Step 2 of 3">
                        <span className="ob-dot" aria-hidden="true"></span>
                        <span className="ob-dot ob-dot--active" aria-hidden="true"></span>
                        <span className="ob-dot" aria-hidden="true"></span>
                    </div>

                    <div className="ob-btn-wrap" ref={btnRef}>
                        <Link to="/onboarding3" className="ob-link" aria-label="Go to the next onboarding step">
                            <Btn btnt="NEXT" />
                        </Link>
                    </div>

                </main>
            </div>
        </div>
    );
};

export default Onboarding2;